import type { ReactNode } from 'react';
import type { WithdrawnInfoRequestForClient } from '@steward-app/steward-types';
import { UserText } from '../../components/UserText';
import { WITHDRAWN_HEADING, WITHDRAWN_LINE_AFTER_FIRM, requestTitle } from './infoRequestsModel';

/*
 * In its own file because the sent screen (`OnboardingClientScreens.tsx`) renders it and is
 * reachable from the public intake page, which must not import the Requests step's query client
 * (`src/intake/intakeBundleImports.test.ts` is what goes red).
 */

/** Requests the firm withdrew that hold a file or answer of the client's: read-only, titles only. */
export function WithdrawnRequests({ firmCap, withdrawn, testId }: {
  /** The firm's name as it starts a sentence. */
  firmCap: ReactNode;
  withdrawn: readonly WithdrawnInfoRequestForClient[];
  testId: string;
}) {
  if (withdrawn.length === 0) return null;
  return (
    <section aria-labelledby={`${testId}-heading`} data-testid={testId} className="mt-6 flex flex-col gap-1">
      <h3 id={`${testId}-heading`} className="m-0 text-[12px] font-semibold text-navy font-sans">{WITHDRAWN_HEADING}</h3>
      <p className="m-0 text-[12px] text-slate font-sans">{firmCap}{WITHDRAWN_LINE_AFTER_FIRM}</p>
      <ul className="m-0 pl-5 text-[13px] text-mid font-sans">
        {withdrawn.map((r) => <li key={r.id}><UserText>{requestTitle(r)}</UserText></li>)}
      </ul>
    </section>
  );
}
